export const getFormattedDateParts = (dateString) => {
  if (!dateString) return { day: "", month: "" };
  const date = new Date(dateString + "T00:00:00");
  if (isNaN(date.getTime())) return { day: "", month: "" };
  return {
    day: date.getDate(),
    month: date.toLocaleDateString("es-ES", { month: "short" }),
  };
};

export const getSimpleReminder = (date) => {
  if (!date) return null;

  const today = new Date();
  const d = new Date(date.length === 10 ? `${date}T00:00:00` : date);
  const diff = Math.floor((d - today) / (1000 * 60 * 60 * 24));

  if (diff === 0) return { label: "Hoy", color: "bg-blue-100 text-blue-700" };
  if (diff <= 3) return { label: "Próximo", color: "bg-emerald-100 text-emerald-700" };

  return null;
};

export const parseEventDate = (value) => {
  if (!value) return null;
  const date = typeof value === "string" && value.length === 10 ? `${value}T00:00:00` : value;
  const parsed = new Date(date);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const isEventDone = (item) => {
  const lastDate = item.end_date || item.date || item.start_date || item.visit_date;
  const d = parseEventDate(lastDate);
  if (!d) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  d.setHours(0, 0, 0, 0);
  return d < today;
};

export const getEventStatus = (item) => {
  if (isEventDone(item)) {
    return { label: "Hecho", color: "bg-slate-200 text-slate-500" };
  }
  return getSimpleReminder(item.date || item.start_date || item.visit_date);
};

export const sortByEventDate = (a, b) => {
  const aDate = parseEventDate(a.date || a.start_date || a.visit_date);
  const bDate = parseEventDate(b.date || b.start_date || b.visit_date);
  if (!aDate && !bDate) return 0;
  if (!aDate) return 1;
  if (!bDate) return -1;
  return aDate - bDate;
};

export const getEventType = (e) => {
  if (e.type === "personal") return "Personal";
  if (e.church_id) return "Iglesia";
  if (e.district_id && !e.church_id) return "Campo";
  return "Personal";
};

export const TYPE_STYLES = {
  Campo: "bg-purple-100 text-purple-700",
  Iglesia: "bg-blue-100 text-blue-700",
  Personal: "bg-amber-100 text-amber-700",
};
